import React from 'react'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import { DataTableRowActions } from '../data-table-row-action'
import { CheckCircledIcon, CrossCircledIcon } from '@radix-ui/react-icons'
import { Card, CardContent } from '@/components/ui/card'
import MyDataTable from 'components/ui/my-data-table'
import Loader from '@/components/ui/Loader'
import useSWR from 'swr'
import DataTableToolbar from '../data-table-toolbar'
import { DataTableRowText } from '../data-table-row-action'
import { openOnlinesByPainter } from 'commons/worksLinks'

export default function FakePainters() {
  const {
    data = [],
    isLoading,
    isValidating,
    mutate,
  } = useSWR(['/publishers', { role: 'painter' }])

  const columns = [
    {
      header: '#',
      cell: ({ row }) => row.index + 1,
    },
    {
      header: 'Nick name',
      accessorKey: 'nick_name',
      cell: ({ row }) => <DataTableRowText row={row} entityKey="nick_name" />,
    },
    {
      header: 'Avatar',
      accessorKey: 'photoUrl',
      cell: ({ row }) => (
        <img src={row.original.photoUrl} alt="avatar" className="w-10 h-10" />
      ),
    },
    {
      header: 'Frame count',
      accessorKey: 'frameCount',
      cell: ({ row }) => (
        <button
          type="button"
          className="font-medium underline underline-offset-4"
          onClick={() => openOnlinesByPainter(row.original.id)}
        >
          {row.original.frameCount ?? row.original.onlineTemplateCount ?? 0}
        </button>
      ),
    },
    {
      header: 'Template count',
      accessorKey: 'templateCount',
      cell: ({ row }) => row.original.templateCount ?? 0,
    },
    {
      header: 'Role',
      accessorKey: 'roles',
      cell: ({ row }) => (
        <>
          {row.original?.roles?.map((role, index) => (
            <Badge variant="outline" key={index}>
              <small>{role}</small>
            </Badge>
          ))}
        </>
      ),
    },
    {
      header: 'State',
      accessorKey: 'state',
      cell: ({ row }) => (
        <>
          {row.original?.state === 0 ? (
            <CheckCircledIcon color="green" />
          ) : (
            <CrossCircledIcon color="red" />
          )}
        </>
      ),
    },
    {
      header: 'Actions',
      cell: ({ row }) => (
        <DataTableRowActions row={row} worksTarget="onlines" />
      ),
    },
  ]

  const table = useReactTable({
    data: data,
    columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <div className="flex h-[calc(100vh-150px)] flex-col">
      {isLoading || isValidating ? (
        <Loader>Loading Painters...</Loader>
      ) : (
        <>
          <div className="mb-2 flex-shrink-0">
            <DataTableToolbar mutate={mutate} role={'painter'} />
          </div>
          <div className="min-h-0 flex-1">
            <Card className="h-full overflow-y-auto">
              <CardContent className="pr-0">
                <MyDataTable table={table} />
              </CardContent>
            </Card>
          </div>
        </>
      )}
    </div>
  )
}
